import React , {useEffect,useRef} from 'react'
import lottie from 'lottie-web'
import style  from '../../styles/mystyle.module.css'
import { useTranslation } from 'next-i18next'
import * as config  from '../../next.config.js'


export default function NoData(props) {
    const lottieDiv=React.useRef()
    const {t}=useTranslation("common")
    React.useEffect(() => {
      
        let instance= lottie.loadAnimation({
            container:lottieDiv.current,
            
            loop:true,
            autoplay:true,
              renderer:"svg",
            path:`${config.basePath}/json/error.json`,
            rendererSettings: {
             className:style.svglottie,
                id:"imgSuccess"

            
            }
        })

  

        return()=>  instance.destroy()
    }, [])
    return (
        <div  className={style.SectionContainer}>
        <div  className={style.allcard}>
        <div className={style.animation} ref={lottieDiv}></div>
        <div className={style.FlexColumn}>
            <p className={style.sizepricetext + " "  + " " + " " + style.marginZero} style={{fontWeight:"bolder"}}>{t("Sorry")}</p>
        
            <p className={style.sizepricetext + " " + style.marginZero}>{props.text? props.text:t("Notfound")}</p>
 
        </div>
        </div>
        </div>
    )
}
